export const COPY_BARCODE_PATTERN = /^\d{12}$/;

const MIN_COPY_BARCODE = 100_000_000_000;
const COPY_BARCODE_RANGE = 900_000_000_000;
const MAX_RANDOM_INTEGER = 0x20000000000000;

const getRandomUnit = (): number => {
  if (globalThis.crypto?.getRandomValues) {
    const bytes = new Uint32Array(2);
    globalThis.crypto.getRandomValues(bytes);
    const random53BitInteger = (bytes[0] * 0x200000) + (bytes[1] >>> 11);
    return random53BitInteger / MAX_RANDOM_INTEGER;
  }

  return Math.random();
};

export const generateCopyBarcode = (): string => {
  const value = MIN_COPY_BARCODE + Math.floor(getRandomUnit() * COPY_BARCODE_RANGE);
  return String(value);
};

export const sanitizeCopyBarcode = (barcode: string): string => {
  return barcode.replace(/\D/g, '').slice(0, 12);
};
